export default __webpack_public_path__ + "917b27f0ba845b9ae9ffd1994a6b1dae.png";